import { render, staticRenderFns } from "./versionRevert.vue?vue&type=template&id=452f03a8&scoped=true"
import script from "./versionRevert.vue?vue&type=script&lang=js"
export * from "./versionRevert.vue?vue&type=script&lang=js"
import style0 from "./versionRevert.vue?vue&type=style&index=0&id=452f03a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452f03a8",
  null
  
)

export default component.exports